export default function anonymous(props
/*``*/) {
var out='<div class="'+(props.styles.playControl)+'" data-hook="playback-control" data-is-playing="false"> <button class="'+(props.styles.playbackToggle)+' '+(props.styles.controlButton)+'" data-hook="playback-control" aria-label="'+(props.texts.label)+'" type="button" tabindex="0"/></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/controls/play/templates/control.dot
// module id = 216
// module chunks = 0 1 2 3 4